var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_414_17034)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "white",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 0.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 12.5,
    width: 3,
    height: 3,
    fill: "#626262",
    stroke: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_414_17034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNine);
export default __webpack_public_path__ + "static/media/nine.b2be57242460df46b5d97e29eed0bdb4.svg";
export { ForwardRef as ReactComponent };